var CustomDB2 = {};

CustomDB2.DeliveryDate = (function () {
  

  
  var ZIPToZone = {
    '005': 1,
    '006': 7,
    '007': 7,
    '008': 7,
    '009': 7,
    '01': 1,
    '020': 1,
    '021': 1,
    '022': 1,
    '023': 1,
    '024': 1,
    '025': 1,
    '026': 1,
    '027': 1,
    '028': 1,
    '029': 1,
    '030': 1,
    '031': 1,
    '032': 1,
    '033': 1,
    '034': 1,
    '035': 1,
    '036': 1,
    '037': 1,
    '038': 1,
    '039': 1,
    '04': 1,
    '05': 1,
    '06': 1,
    '07': 1,
    '08': 1,
    
    '09': 9,
    '10': 1,
    '11': 1,
    '12': 1,
    '13': 1,
    '14': 1,
    '15': 2,
    '16': 2,
    '17': 2,
    '18': 2,
    '190': 2,
    '191': 2,
    '192': 2,
    '193': 2,
    '194': 2,
    '195': 2,
    '196': 2,
    '197': 2,
    '198': 2,
    '199': 2,
    '200': 2,
    '201': 2,
    '202': 2,
    '203': 2,
    '204': 2,
    '205': 2,
    '206': 2,
    '207': 2,
    '208': 2,
    '209': 2,
    '21': 2,
    '22': 2,
    '23': 2,
    '240': 2,
    '241': 2,
    '242': 2,
    '243': 2,
    '244': 2,
    '245': 2,
    '246': 2,
    '247': 2,
    '248': 2,
    '249': 2,
    '25': 2,
    '26': 2,
    '27': 3,
    '28': 3,
    '29': 3,
    '30': 3,
    '31': 3,
    '32': 4,
    '33': 4,
    
    '340': 9,
    '341': 4,
    '342': 4,
    '343': 4,
    '344': 4,
    '345': 4,
    '346': 4,
    '347': 4,
    '348': 4,
    '349': 4,
    '35': 4,
    '36': 4,
    '37': 3,
    '380': 3,
    '381': 3,
    '382': 3,
    '383': 3,
    '384': 3,
    '385': 3,
    '386': 4,
    '387': 4,
    '388': 4,
    '389': 4,
    '390': 4,
    '391': 4,
    '392': 4,
    '393': 4,
    '394': 4,
    '395': 4,
    '396': 4,
    '397': 4,
    '398': 3,
    '399': 3,
    '40': 3,
    '41': 3,
    '42': 3,
    '43': 3,
    '44': 3,
    '45': 3,
    '46': 3,
    '47': 3,
    '48': 3,
    '49': 3,
    '50': 4,
    '51': 4,
    '52': 4,
    '53': 3,
    '54': 3,
    '55': 4,
    '560': 4,
    '561': 4,
    '562': 4,
    '563': 4,
    '564': 4,
    '565': 4,
    '566': 4,
    '567': 4,

    '569': 2,
    '57': 5,
    '58': 5,
    '59': 5,
    '60': 3,
    '61': 3,
    '62': 3,
    '63': 4,
    '64': 4,
    '65': 4,
    '66': 5,
    '67': 5,
    '68': 5,
    '69': 5,
    '70': 4,
    '710': 4,
    '711': 4,
    '712': 4,
    '713': 4,
    '714': 4,
    '715': 4,
    '716': 4,
    '717': 4,
    '718': 4,
    '719': 4,
    '72': 4,
    '73': 5,
    '74': 5,
    '75': 5,
    '76': 5,
    '77': 5,
    '78': 5,
    '79': 5,
    '80': 5,
    '81': 5,
    '82': 5,
    '830': 5,
    '831': 5,
    '832': 6,
    '833': 6,
    '834': 6,
    '835': 6,
    '836': 6,
    '837': 6,
    '838': 6,
    '839': 6,
    '84': 6,
    '85': 6,
    '86': 6,
    '87': 6,
    '880': 6,
    '881': 6,
    '882': 6,
    '883': 6,
    '884': 6,
    '885': 5,

    '889': 6,
    '89': 6,
    '90': 6,
    '91': 6,
    '92': 6,
    '93': 6,
    '94': 6,
    '95': 6,
    '960': 6,
    '961': 6,
    
    '962': 9,
    '963': 9,
    '964': 9,
    '965': 9,
    '966': 9,
    '967': 7,
    '968': 7,
    
    '97': 6,
    '98': 6,
    '990': 6,
    '991': 6,
    '992': 6,
    '993': 6,
    '994': 6,
    '995': 7,
    '996': 7,
    '997': 7,
    '998': 7,
    '999': 7,
  };

  
  var ZIPExceptionAS = '96799';

  
  var days = {

    CA: [7, 6, 5, 4, 3, 2, 3, 5],
    CA2: [8, 7, 6, 5, 4, 3, 4, 6],
    FL: [3, 3, 3, 3, 4, 5, 3, 5],
    IL: [4, 4, 2, 3, 4, 5, 3, 5],
    IL2: [5, 5, 3, 4, 5, 6, 4, 6],
    MA: [2, 3, 4, 5, 6, 7, 3, 5],
    ME: [2, 3, 4, 5, 6, 7, 3, 5],
    NJ: [2, 2, 3, 4, 5, 6, 3, 5],
    NY: [2, 2, 3, 4, 5, 6, 3, 5],
    OK: [7, 5, 4, 3, 2, 3, 3, 5],
    PA: [2, 2, 3, 4, 5, 6, 3, 5],
    TX: [7, 5, 4, 3, 2, 3, 3, 5],
    VA: [2, 2, 3, 4, 5, 6, 3, 5],
    WA: [7, 6, 5, 4, 3, 2, 3, 5],

    Australia: [6, 6, 6, 6, 6, 6, 6, 5],
    Belgium: [4, 4, 4, 4, 4, 4, 4, 5],
    Canada: [3, 3, 3, 3, 4, 5, 3, 5],
    China: [7, 7, 7, 7, 7, 7, 7, 6],
    France: [4, 4, 4, 4, 4, 4, 4, 5],
    India: [6, 6, 6, 6, 6, 6, 6, 5],
    Lebanon: [4, 4, 4, 4, 4, 4, 4, 5],
    Spain: [6, 6, 6, 6, 6, 6, 6, 5],
    Turkey: [6, 6, 6, 6, 6, 6, 6, 5],
    Turkey2: [4, 4, 4, 4, 4, 4, 4, 5],
  };

  
  var mainDataset = {
    'Abby Paris': [
      { from: 1, to: 199, time: 2, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Alyce': [
      { from: 1, to: 199, time: 2, days: days.IL },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Amarra': [
      { from: 1, to: 499, time: 2, days: days.NJ },
    ],
    'Andrea and Leo': [
      { from: 1, to: 199, time: 4, days: days.CA2 },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Angela and Alison': [
      { from: 1, to: 199, time: 2, days: days.Canada },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Anny Lee': [
      { from: 1, to: 199, time: 4, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Ashley Lauren': [
      { from: 1, to: 199, time: 2, days: days.ME },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Ava Presley': [
      { from: 1, to: 199, time: 3, days: days.TX },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Cameron Blake': [
      { from: 1, to: 199, time: 2, days: days.IL },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Cecilia Couture': [
      { from: 1, to: 199, time: 4, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Chic and Holland': [
      { from: 201, to: 299, time: 2, days: days.NY },
      { from: 401, to: 499, time: 2, days: days.Belgium, isPreOrder: true },
    ],
    'Cinderella Divine': [
      { from: 1, to: 199, time: 4, days: days.CA2 },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Clarisse': [
      { from: 1, to: 499, time: 2, days: days.PA },
    ],
    'Colette': [
      { from: 1, to: 199, time: 2, days: days.IL },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Colors Dress': [
      { from: 1, to: 499, time: 2, days: days.NJ },
    ],
    'Couture Fashion by FG': [
      { from: 1, to: 199, time: 2, days: days.India },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Daymor': [
      { from: 1, to: 499, time: 2, days: days.MA },
    ],
    'Dulce Celia': [
      { from: 1, to: 199, time: 2, days: days.NY },
      { from: 401, to: 499, time: 2, days: days.France, isPreOrder: true },
    ],
    'Edition Gemmy Malouf': [
      { from: 1, to: 199, time: 2, days: days.NY },
      { from: 401, to: 499, time: 2, days: days.Lebanon, isPreOrder: true },
    ],
    'Edward Arsouni Couture': [
      { from: 1, to: 199, time: 2, days: days.NY },
      { from: 401, to: 499, time: 2, days: days.Lebanon, isPreOrder: true },
    ],
    'Elizabeth K': [
      { from: 1, to: 199, time: 4, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Ellie Wilde': [
      { from: 1, to: 199, time: 2, days: days.IL },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Faviana': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'Fely Campo': [
      { from: 1, to: 199, time: 2, days: days.Spain },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Feriani': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'Gatti Nolli Couture': [
      { from: 1, to: 199, time: 2, days: days.NY },
      { from: 401, to: 499, time: 2, days: days.Lebanon, isPreOrder: true },
    ],
    'Gia Franco': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'GLS by Gloria': [
      { from: 1, to: 199, time: 4, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Ilmio': [
      { from: 1, to: 199, time: 2, days: days.Turkey },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'In Couture': [
      { from: 1, to: 199, time: 2, days: days.Turkey },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Issue NY': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'Ivonne D': [
      { from: 1, to: 199, time: 2, days: days.IL },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Jadore': [
      { from: 1, to: 199, time: 2, days: days.Canada },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Janique': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'Jean Louis Sabaji': [
      { from: 1, to: 199, time: 2, days: days.NY },
      { from: 401, to: 499, time: 2, days: days.Lebanon, isPreOrder: true },
    ],
    'Johnathan Kayne': [
      { from: 1, to: 199, time: 3, days: days.OK },
      { from: 201, to: 299, time: 2, days: days.NY },
      { from: 401, to: 499, time: 3, days: days.OK, isPreOrder: true },
    ],
    'Jovani': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'JVN by Jovani': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'LaDivine': [
      { from: 1, to: 199, time: 4, days: days.CA2 },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'La Femme': [
      { from: 1, to: 199, time: 4, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
      { from: 401, to: 499, time: 4, days: days.CA, isPreOrder: true },
    ],
    'Lara': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'Les Demoiselle': [
      { from: 1, to: 199, time: 2, days: days.Australia },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Lucci Lu': [
      { from: 1, to: 199, time: 2, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Mac Duggal': [
      { from: 1, to: 199, time: 2, days: days.IL2 },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Marsoni': [
      { from: 1, to: 499, time: 2, days: days.NJ },
    ],
    'MGNY': [
      { from: 1, to: 199, time: 2, days: days.FL },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'MINNA': [
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'MNM Couture': [
      { from: 1, to: 199, time: 2, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Montage': [
      { from: 1, to: 199, time: 2, days: days.IL },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Nox Anabel': [
      { from: 1, to: 199, time: 4, days: days.CA },
      { from: 201, to: 299, time: 4, days: days.NY },
    ],
    'Odrella': [
      { from: 1, to: 199, time: 2, days: days.Turkey },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Park 108': [
      { from: 1, to: 499, time: 2, days: days.MA },
    ],
    'Paul Rekhi': [
      { from: 1, to: 199, time: 2, days: days.VA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Portia and Scarlett': [
      { from: 1, to: 199, time: 4, days: days.China },
      { from: 201, to: 299, time: 2, days: days.NY },
      { from: 301, to: 399, time: 4, days: days.CA },
    ],
    'Primavera Couture': [
      { from: 1, to: 199, time: 2, days: days.FL },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Rachel Allan': [
      { from: 1, to: 199, time: 3, days: days.TX },
      { from: 201, to: 299, time: 2, days: days.NY },
      { from: 401, to: 499, time: 3, days: days.TX, isPreOrder: true },
    ],
    'Reverie Couture': [
      { from: 1, to: 199, time: 2, days: days.NY },
      { from: 401, to: 499, time: 2, days: days.Turkey2, isPreOrder: true },
    ],
    'Rina Di Montella': [
      { from: 1, to: 499, time: 2, days: days.NJ },
    ],
    'Scala': [
      { from: 1, to: 199, time: 2, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Sherri Hill': [
      { from: 1, to: 199, time: 3, days: days.TX },
      { from: 201, to: 299, time: 2, days: days.NY },
      { from: 401, to: 499, time: 3, days: days.TX, isPreOrder: true },
    ],
    'Sydneys Closet': [
      { from: 1, to: 199, time: 2, days: days.WA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Tarik Ediz': [
      { from: 1, to: 199, time: 2, days: days.Turkey },
      { from: 401, to: 499, time: 2, days: days.Turkey2, isPreOrder: true },
    ],
    'Terani': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'Tiara': [
      { from: 1, to: 199, time: 2, days: days.Turkey },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
  };

  function getZone(country, ZIP) {
    if (country === 'Puerto Rico') return 7;
    if (country !== 'United States') return 8;

    if (ZIP === ZIPExceptionAS) return 8;

    var zone = ZIPToZone[ZIP.slice(0, 2)];
    if (zone) return zone;
    
    zone = ZIPToZone[ZIP.slice(0, 3)];
    if (zone) return zone;
    return 8;
  }

  function get(vendor, inventoryQuantity, country, ZIP) {
    if (!vendor || !inventoryQuantity || !country) return null;
    if (country === 'United States' && !/^\d{5}$/.test(ZIP)) return null;
    var zone = getZone(country, ZIP);
    if (zone === 9) return { isMilitary: true };
    var vendorLocations = mainDataset[vendor];
    if (!vendorLocations) return null;
    var vendorLocation = vendorLocations.find(function (v) {
      return inventoryQuantity >= v.from && inventoryQuantity <= v.to;
    });
    if (!vendorLocation) return null;
    var days = vendorLocation.days[zone - 1];
    if (vendorLocation.isPreOrder) return { days: days, isPreOrder: true };
    return { cutoffTime: vendorLocation.time, days: days };
  }

  return {
    get: get,
  };
}());
